export const searchItems = [
  { name: "iphone", id: "1" },
  { name: "ekbord", id: "2" },
  { name: "laptop", id: "3" },
]

export const allAreas = [
  { name: "Hela Sverige", id: "1" },
  { name: "Göteborg", id: "2" },
  { name: "Malmö", id: "3" },
  { name: "Linköping", id: "4" },
  { name: "Helsingborg", id: "5" },
  { name: "Åmål", id: "6" },
  { name: "Luleå", id: "7" },
  { name: "Visby", id: "8" },
  { name: "Halmstad", id: "9" },
  { name: "Dalarna", id: "10" },
  { name: "Jämtland", id: "11" },
  { name: "Norrbotten", id: "12" },
  { name: "Stockholm", id: "13" },
]

export const allCategories = [
  { id: "1", category: "Jobb", img: require("../img/icons8-bag-91.png") },
  { id: "2", category: "Fordon", img: require("../img/icons8-car-100.png") },
  {
    id: "3",
    category: "För hemmet",
    img: require("../img/icons8-couch-64.png"),
  },
  {
    id: "4",
    category: "Bostad",
    img: require("../img/icons8-exterior-40.png"),
  },
  {
    id: "5",
    category: "Personligt",
    img: require("../img/icons8-t-shirt-100.png"),
  },
  {
    id: "6",
    category: "Elektronik",
    img: require("../img/icons8-iphone-se-100.png"),
  },
  {
    id: "7",
    category: "Fritid & hobby",
    img: require("../img/icons8-sports-48.png"),
  },
  {
    id: "8",
    category: "Affärsverksamhet",
    img: require("../img/icons8-small-business-40.png"),
  },
  {
    id: "9",
    category: "Övrigt",
    img: require("../img/icons8-open-box-48.png"),
  },
]

export const safetyItems = [
  "Kundsäkerhet",
  "Frakt med säker betalning",
  "Falska mail",
  "Anmäl störande reklam",
]

export const termsItems = [
  "Användarvillkor",
  "Personuppgiftshantering",
  "Cookies",
]

export const businessItems = [
  "För företag",
  "Öppna butik",
  "Öppna fordonsbutik",
  "Visa alla butiker",
  "Inloggning för butiker",
  "Administrera butiksannonser",
]

export const blocketItems = [
  "Om Blocket",
  "Press",
  "Jobba på Blocket",
  "Kontakta oss",
  "Inspiration",
  "Tips och guider",
]

export const fordonItems = [
  "Bilar",
  "Bildelar & biltillbehör",
  "Båtar",
  "Båtdelar & tillbehör",
  "Husvagnar & husbilar",
  "Mopeder & A-traktor",
  "Motorcyklar",
  "MC-delar & tillbehör",
  "Lastbil, truck & entreprenad",
  "Skogs- & lantbruksmaskiner",
  "Snöskotrar",
  "Snöskoterdelar & tillbehör",
]

export const homeItems = [
  "Bygg & trädgård",
  "Möbler & heminredning",
  "Husgeråd & vitvaror",
  "Verktyg",
]

export const personalItems = [
  "Kläder & skor",
  "Accessoarer & klockor",
  "Barnkläder & skor",
  "Barnartiklar & leksaker",
]

export const electricItems = [
  "Datorer & TV-spel",
  "Ljud & bild",
  "Telefoner & tillbehör",
]

export const hobbyItems = [
  "Upplevelser & nöje",
  "Böcker & studentlitteratur",
  "Cyklar",
  "Djur",
  "Hobby & samlarprylar",
  "Hästar & ridsport",
  "Jakt & fiske",
  "Musikutrustning",
  "Sport- & fritidsutrustning",
]

export const operationItems = [
  "Affärsöverlåtelser",
  "Inventarier & maskiner",
  "Lokaler & fastigheter",
  "Tjänster",
]
